(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pdp-product-info"] && !Shopify.designMode) return;
  try {
    // <pdp-info-marquee>: marquee infinito com drag/swipe manual.
  // Roda só no mobile (até 767px). Auto-scroll via requestAnimationFrame
  // + transform translateX. Em pointerdown, pausa o auto-scroll e segue
  // o dedo; em pointerup, retoma o auto-scroll a partir da posição atual.
  if (!customElements.get('pdp-info-marquee')) {
    class PdpInfoMarquee extends HTMLElement {
      connectedCallback() {
        this.mqMobile = window.matchMedia('(max-width: 767px)');
        this.mqMobile.addEventListener('change', this.handleViewportChange.bind(this));
        this.setup();
      }

      disconnectedCallback() {
        this.teardown();
        if (this.mqMobile) this.mqMobile.removeEventListener('change', this.handleViewportChange);
      }

      handleViewportChange() {
        this.teardown();
        this.setup();
      }

      setup() {
        if (!this.mqMobile.matches) return;
        this.track = this.querySelector('.pdp-info__track');
        if (!this.track) return;
        this.originalItems = Array.from(this.track.children);
        if (this.originalItems.length === 0) return;

        // Clona uma vez para permitir loop sem espaço vazio
        this.cloneCount = this.originalItems.length;
        this.originalItems.forEach((item) => {
          const clone = item.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.dataset.clone = 'true';
          this.track.appendChild(clone);
        });

        const speedSec = parseFloat(this.dataset.speed) || 30;
        const half = this.track.scrollWidth / 2 || 1;
        // velocidade em px/segundo (uma volta completa = half px em speedSec)
        this.pxPerSec = half / speedSec;
        this.directionSign = this.dataset.direction === 'right' ? -1 : 1;
        this.offset = 0;
        this.lastT = 0;
        this.dragging = false;
        this.paused = false;
        this.lastPointerX = 0;
        this.dragVelocity = 0;
        this.lastMoveTs = 0;

        this.onPointerDown = this.onPointerDown.bind(this);
        this.onPointerMove = this.onPointerMove.bind(this);
        this.onPointerUp = this.onPointerUp.bind(this);
        this.tick = this.tick.bind(this);

        this.addEventListener('pointerdown', this.onPointerDown);
        this.io = new IntersectionObserver(([entry]) => {
          this.paused = !entry.isIntersecting;
        });
        this.io.observe(this);

        this.rafId = requestAnimationFrame(this.tick);
      }

      teardown() {
        if (this.rafId) cancelAnimationFrame(this.rafId);
        if (this.io) this.io.disconnect();
        if (this.track) {
          // Remove clones para evitar duplicação ao re-configurar
          this.track.querySelectorAll('[data-clone="true"]').forEach((el) => el.remove());
          this.track.style.transform = '';
        }
        this.removeEventListener('pointerdown', this.onPointerDown);
        document.removeEventListener('pointermove', this.onPointerMove);
        document.removeEventListener('pointerup', this.onPointerUp);
        document.removeEventListener('pointercancel', this.onPointerUp);
      }

      tick(t) {
        if (!this.lastT) this.lastT = t;
        const dt = (t - this.lastT) / 1000;
        this.lastT = t;
        const half = this.track.scrollWidth / 2 || 1;
        if (!this.dragging && !this.paused) {
          this.offset += this.pxPerSec * dt * this.directionSign;
        }
        // Wrap em [0, half) para loop perfeito
        this.offset = ((this.offset % half) + half) % half;
        this.track.style.transform = 'translate3d(' + -this.offset + 'px,0,0)';
        this.rafId = requestAnimationFrame(this.tick);
      }

      onPointerDown(e) {
        // Não pega clicks em links/botões dentro dos items (não existem hoje, mas seguro)
        this.dragging = true;
        this.lastPointerX = e.clientX;
        this.lastMoveTs = performance.now();
        if (this.setPointerCapture) {
          try {
            this.setPointerCapture(e.pointerId);
          } catch (_) {}
        }
        document.addEventListener('pointermove', this.onPointerMove);
        document.addEventListener('pointerup', this.onPointerUp);
        document.addEventListener('pointercancel', this.onPointerUp);
      }

      onPointerMove(e) {
        if (!this.dragging) return;
        const delta = e.clientX - this.lastPointerX;
        this.lastPointerX = e.clientX;
        // Direção do drag é independente do directionSign para feedback natural
        this.offset -= delta;
        this.lastMoveTs = performance.now();
      }

      onPointerUp() {
        this.dragging = false;
        document.removeEventListener('pointermove', this.onPointerMove);
        document.removeEventListener('pointerup', this.onPointerUp);
        document.removeEventListener('pointercancel', this.onPointerUp);
      }
    }
    customElements.define('pdp-info-marquee', PdpInfoMarquee);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["shipping-calculator"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    var UF_TO_PROVINCE = {
      AC: 'Acre', AL: 'Alagoas', AP: 'Amapa', AM: 'Amazonas', BA: 'Bahia',
      CE: 'Ceara', DF: 'Distrito Federal', ES: 'Espirito Santo', GO: 'Goias',
      MA: 'Maranhao', MT: 'Mato Grosso', MS: 'Mato Grosso do Sul',
      MG: 'Minas Gerais', PA: 'Para', PB: 'Paraiba', PR: 'Parana',
      PE: 'Pernambuco', PI: 'Piaui', RJ: 'Rio de Janeiro',
      RN: 'Rio Grande do Norte', RS: 'Rio Grande do Sul', RO: 'Rondonia',
      RR: 'Roraima', SC: 'Santa Catarina', SP: 'Sao Paulo', SE: 'Sergipe',
      TO: 'Tocantins'
    };

    function initShippingCalculator(root) {
      if (!root || root.dataset.shippingCalcReady === 'true') return;
      root.dataset.shippingCalcReady = 'true';

      var cepInput = root.querySelector('[data-cep]');
      var button = root.querySelector('[data-calculate]');
      var provinceSelect = root.querySelector('[data-province]');
      var countrySelect = root.querySelector('[data-country]');
      var messageEl = root.querySelector('[data-message]');
      var resultsEl = root.querySelector('[data-results]');
      if (!cepInput || !button) return;

      var text = {
        invalidCep: root.dataset.messageInvalidCep,
        cepNotFound: root.dataset.messageCepNotFound,
        unavailable: root.dataset.messageUnavailable,
        busy: root.dataset.messageBusy,
        freeShipping: root.dataset.freeShippingLabel,
        noEta: root.dataset.noEtaLabel,
        statusCep: root.dataset.statusCep || 'Consultando o CEP…',
        statusRates: root.dataset.statusRates || 'Buscando as opcoes de entrega…'
      };

      var productForm = root.closest('.m-product-form, .m-main-product, form[action*="/cart/add"]') || document;

      function showMessage(msg) {
        resultsEl.innerHTML = '';
        resultsEl.style.display = 'none';
        messageEl.textContent = msg;
        messageEl.style.display = 'block';
      }

      function clearMessage() {
        messageEl.textContent = '';
        messageEl.style.display = 'none';
      }

      function setLoading(isLoading) {
        button.classList.toggle('m-spinner-button--loading', isLoading);
        button.disabled = isLoading;
      }

      function getVariantId() {
        var input = productForm.querySelector('[name="id"]') || document.querySelector('.m-main-product [name="id"]');
        var value = input && input.value;
        return value ? parseInt(value, 10) : null;
      }

      function getQuantity() {
        var input = productForm.querySelector('[name="quantity"]') || document.querySelector('.m-main-product [name="quantity"]');
        var value = input && parseInt(input.value, 10);
        return value && value > 0 ? value : 1;
      }

      function money(cents) {
        var format = (window.MinimogSettings && window.MinimogSettings.money_format) || 'R$ {' + '{amount_with_comma_separator}' + '}';
        if (typeof window.formatMoney === 'function') return window.formatMoney(cents, format);
        if (typeof formatMoney === 'function') return formatMoney(cents, format);
        return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',');
      }

      // Máscara 00000-000
      cepInput.addEventListener('input', function (event) {
        var digits = event.target.value.replace(/\D/g, '').slice(0, 8);
        event.target.value = digits.length > 5 ? digits.slice(0, 5) + '-' + digits.slice(5) : digits;
      });

      cepInput.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          button.click();
        }
      });

      var SPINNER_SVG = '<svg class="animate-spin" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3" opacity="0.25"></circle><path fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path></svg>';

      /** Mostra o formato do resultado e a etapa atual, em vez de um spinner solto. */
      function showSkeleton(statusText) {
        var linhas = '';
        for (var i = 0; i < 3; i++) {
          linhas +=
            '<div class="m-shipping-calc__skeleton">' +
              '<div style="flex:1">' +
                '<div class="m-shipping-calc__bone m-shipping-calc__bone--name"></div>' +
                '<div class="m-shipping-calc__bone m-shipping-calc__bone--eta"></div>' +
              '</div>' +
              '<div class="m-shipping-calc__bone m-shipping-calc__bone--price"></div>' +
            '</div>';
        }
        resultsEl.innerHTML =
          '<div class="m-shipping-calc__status" role="status" aria-live="polite">' +
            SPINNER_SVG + '<span data-status-text></span>' +
          '</div>' + linhas;
        resultsEl.style.display = 'block';
        setStatus(statusText);
      }

      function setStatus(texto) {
        var el = resultsEl.querySelector('[data-status-text]');
        if (el) el.textContent = texto;
      }

      function renderRates(rates) {
        resultsEl.innerHTML = '';

        rates.forEach(function (rate) {
          var price = rate.price === '0.00' || rate.price === null || Number(rate.price) === 0
            ? text.freeShipping
            : money(Number(rate.price) * 100);

          var eta = '';
          if (rate.delivery_date) {
            var date = new Date(rate.delivery_date);
            var today = new Date(new Date().toDateString());
            if (!isNaN(date.getTime()) && date >= today) {
              eta = 'Chega até ' + date.toLocaleDateString('pt-BR');
            } else {
              eta = text.noEta;
            }
          }

          var item = document.createElement('div');
          item.className = 'm-shipping-calc__rate';
          item.innerHTML =
            '<div><p class="m-shipping-calc__rate-name"></p>' +
            (eta ? '<span class="m-shipping-calc__rate-eta"></span>' : '') +
            '</div><div class="m-shipping-calc__rate-price"></div>';
          item.querySelector('.m-shipping-calc__rate-name').textContent = rate.name;
          if (eta) item.querySelector('.m-shipping-calc__rate-eta').textContent = eta;
          item.querySelector('.m-shipping-calc__rate-price').textContent = price;
          resultsEl.appendChild(item);
        });

        resultsEl.style.display = 'block';
      }

      function espera(ms) {
        return new Promise(function (resolve) { setTimeout(resolve, ms); });
      }

      /**
       * fetch que entende o limite da Shopify. Os endpoints de carrinho e de
       * frete respondem 429 quando recebem chamadas em sequencia, o que
       * acontece justamente quando o cliente calcula, muda a quantidade e
       * calcula de novo. Em vez de estourar, espera e tenta outra vez com
       * intervalo crescente. Qualquer outro erro HTTP vira excecao: antes o
       * codigo tentava ler como JSON uma pagina de erro HTML.
       */
      function pede(url, opts, tentativa) {
        tentativa = tentativa || 0;
        var config = Object.assign({ credentials: 'same-origin' }, opts || {});
        return fetch(url, config).then(function (response) {
          if (response.status === 429) {
            if (tentativa < 3) {
              return espera(1500 * (tentativa + 1)).then(function () { return pede(url, opts, tentativa + 1); });
            }
            var ocupado = new Error('limite de requisicoes da Shopify');
            ocupado.code = 'busy';
            throw ocupado;
          }
          if (!response.ok) {
            var erro = new Error('HTTP ' + response.status + ' em ' + url);
            erro.status = response.status;
            throw erro;
          }
          return response.text().then(function (corpo) { return corpo ? JSON.parse(corpo) : null; });
        });
      }

      /**
       * Fluxo assincrono documentado da Shopify para frete de transportadora
       * (a Frete Rapido calcula por fora): prepara a cotacao e consulta ate ela
       * ficar pronta. O /cart/shipping_rates.json direto as vezes devolvia a
       * lista vazia porque a transportadora ainda nao tinha respondido.
       */
      function cotaFrete(qs, tentativa) {
        tentativa = tentativa || 0;
        var consulta = tentativa === 0
          ? pede('/cart/prepare_shipping_rates.json?' + qs, { method: 'POST' }).then(function () {
              return pede('/cart/async_shipping_rates.json?' + qs);
            })
          : pede('/cart/async_shipping_rates.json?' + qs);
        return consulta.then(function (data) {
          if (data) return data;
          if (tentativa >= 12) return { shipping_rates: [] };
          return espera(1000).then(function () { return cotaFrete(qs, tentativa + 1); });
        });
      }

      // Evita refazer a troca do carrinho para a mesma consulta: o cliente
      // clicando de novo em "Calcular" nao gasta requisicao nenhuma.
      var cotacoes = {};

      /**
       * A cotacao so considera o carrinho inteiro, entao o carrinho e trocado
       * temporariamente pelo produto da pagina e depois devolvido. A
       * devolucao usa o mesmo pede() com novas tentativas: se ela falhar, o
       * cliente perde os itens que ja tinha escolhido, que e bem pior do que
       * uma cotacao que nao saiu.
       */
      function quoteForCurrentProduct(variantId, quantity) {
        var chave = variantId + '|' + quantity + '|' + cepInput.value.replace(/\D/g, '');
        if (cotacoes[chave]) return Promise.resolve(cotacoes[chave]);

        var savedItems = [];

        function restoreCart() {
          // Sempre limpa: se o carrinho estava vazio, o produto usado na cotacao
          // nao pode ficar la, o cliente nao adicionou nada.
          return pede('/cart/clear.js', { method: 'POST' })
            .then(function () {
              if (!savedItems.length) return null;
              return pede('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  items: savedItems.map(function (item) {
                    return { id: item.variant_id, quantity: item.quantity, properties: item.properties };
                  })
                })
              });
            })
            .catch(function (error) {
              console.error('[frete] falha ao restaurar o carrinho:', error);
            });
        }

        var params = new URLSearchParams({
          'shipping_address[country]': countrySelect.value,
          'shipping_address[province]': provinceSelect.value,
          'shipping_address[zip]': cepInput.value
        });

        return pede('/cart.js')
          .then(function (cart) {
            savedItems = (cart && cart.items) || [];
            return pede('/cart/clear.js', { method: 'POST' });
          })
          .then(function () {
            return pede('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: variantId, quantity: quantity })
            });
          })
          .then(function () { return cotaFrete(params.toString()); })
          .then(function (data) {
            return restoreCart().then(function () {
              if (data && data.shipping_rates && data.shipping_rates.length) cotacoes[chave] = data;
              return data;
            });
          })
          .catch(function (error) {
            return restoreCart().then(function () { throw error; });
          });
      }

      button.addEventListener('click', function (event) {
        event.preventDefault();

        var cep = cepInput.value.replace(/\D/g, '');
        if (cep.length !== 8) {
          showMessage(text.invalidCep);
          return;
        }

        var variantId = getVariantId();
        if (!variantId) {
          console.error('[frete] variante do produto não encontrada na página');
          showMessage(text.unavailable);
          return;
        }

        clearMessage();
        setLoading(true);
        showSkeleton(text.statusCep);

        fetch('https://viacep.com.br/ws/' + cep + '/json/')
          .then(function (response) { return response.json(); })
          .then(function (data) {
            // CEP realmente não existe — aqui sim a culpa é do número digitado.
            if (data.erro) {
              showMessage(text.cepNotFound);
              return null;
            }
            provinceSelect.value = UF_TO_PROVINCE[data.uf] || data.uf;
            setStatus(text.statusRates);
            return quoteForCurrentProduct(variantId, getQuantity());
          })
          .then(function (data) {
            if (!data) return;
            if (data.shipping_rates && data.shipping_rates.length) {
              renderRates(data.shipping_rates);
            } else {
              // CEP válido, mas a transportadora não devolveu cotação.
              console.warn('[frete] sem opções de entrega para o CEP consultado');
              showMessage(text.unavailable);
            }
          })
          .catch(function (error) {
            console.error('[frete] falha ao calcular:', error);
            showMessage(error && error.code === 'busy' && text.busy ? text.busy : text.unavailable);
          })
          .finally(function () {
            setLoading(false);
          });
      });
    }

    function initAll() {
      document.querySelectorAll('[data-shipping-calc]').forEach(initShippingCalculator);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    // O editor de temas recarrega a seção sem recarregar a página.
    document.addEventListener('shopify:section:load', initAll);
  })();
  } catch(e) { console.error(e); }
})();

})();
